(function () {
    "use strict";

    angular
        .module("app")
        .directive("upperDescriptionSearchHelp", ["SearchFactory", upperDescriptionSearchHelp]);

    function upperDescriptionSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.pictogramKey = "";
                        scope.upperDesc = "";
                        scope.liningDesc = "";
                        scope.outsoleDesc = "";
                        scope.displayValue = "";
                        scope.prevDisplayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.upperDesc === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.upperDescriptionSearch(function (upperDescription) {
                        scope.pictogramKey = upperDescription ? upperDescription.PictogramKey : "";
                        scope.upperDesc = upperDescription ? upperDescription.UpperDesc : "";
                        scope.liningDesc = upperDescription ? upperDescription.LiningDesc : "";
                        scope.outsoleDesc = upperDescription ? upperDescription.OutsoleDesc : "";
                        scope.displayValue = scope.upperDesc;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue, "", "", ""]);
                };

                scope.$watch("upperDesc", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.upperDesc;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { pictogramKey: "=", upperDesc: "=", liningDesc: "=", outsoleDesc: "=", readOnly: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

